import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { EntityProperties } from "@ryde/controls";
import { RideCrudModeKey, type EntityProperty } from "@ryde/shared";

import { INVESTIGATION_HISTORY } from "../investigation.constants";

interface IInvestigationHistoryFieldDetailsProps {
  details: EntityProperty[];
}

/** Every field an audited change wrote, collapsed — the same list the ride history drawer shows when a row opens. */
export const InvestigationHistoryFieldDetails: FC<
  IInvestigationHistoryFieldDetailsProps
> = ({ details }) => {
  const { t } = useTranslation();

  if (!details.length) {
    return null;
  }

  return (
    <details className="history-payload">
      <summary>{t(`${INVESTIGATION_HISTORY.i18nKey}.fieldDetails`)}</summary>
      <EntityProperties entity={RideCrudModeKey.uiUnit} data={details} />
    </details>
  );
};
